//Entries

import axios from 'axios';
import calculateBlocks from '../helpers/calculateBlocks.js';
import { message } from 'antd';
import { completeLesson, removeCompletion } from './course.js';

//Runs on course mounting, grabs all for a poem
export function requestEntries(poemID) {
  const url = `/api/entries/${poemID}`;
  const request = axios.get(url);

  return function(dispatch) {
    request.then(function(res) {
      const entries = res.data;

      dispatch({
        type: 'REQUEST_ENTRIES',
        entries: entries
      });

    }).catch((error) => console.log(error));
  }
}

//Calculates blocks based on marked words, then saves
export function saveBlocks(){
  return function(dispatch, getState){
    const state = getState();
    const {markedWords} = state.blocking;
    const {lines} = state.course.text;
    let blocks = calculateBlocks(markedWords, lines),
        poemID = state.course.url.poem;
    blocks.marked = markedWords;
    const url = `/api/entries/`,
          update = {blocks: blocks};
    axios.post(url, {update, poemID}).then((res) => {
      const entries = res.data;
      message.success('Blocks Saved');

      dispatch({
        type: 'UPDATE_BLOCKS',
        entries: entries
      });
      dispatch(completeLesson());
    }).catch(err => {
      console.log(err);
      const errMsg = err.response ? err.response.data.error : '';
      message.error('Save Failed: ' + errMsg);
    });
  }
}

export function submitSummaries(){
  return function(dispatch, getState){
    const state = getState();
    const poemID = state.course.url.poem,
          summaries = state.blockSummary.summaries;

    const url = `/api/entries/`,
          update = {summaries: summaries};
    axios.post(url, {update, poemID}).then((res) => {
      const entries = res.data;

      message.success('Summaries Saved');

      dispatch({
        type: 'UPDATE_ENTRIES',
        entries: entries
      });
      dispatch(completeLesson());
    }).catch(err => {
      console.log(err);
      const errMsg = err.response ? err.response.data.error : '';
      message.error('Save Failed: ' + errMsg);
    });
  }
}

export function submitReflection(text){
  return function(dispatch, getState){
    const state = getState();
    const poemID = state.course.url.poem;

    const url = `/api/entries/`,
          update = {reflection: text};
    axios.post(url, {update, poemID}).then((res) => {
      const entries = res.data;

      message.success('Reflection Saved');

      dispatch({
        type: 'UPDATE_ENTRIES',
        entries: entries
      });
      dispatch(completeLesson());
    }).catch(err => {
      console.log(err);
      const errMsg = err.response ? err.response.data.error : '';
      message.error('Save Failed: ' + errMsg);
    });
  }
}

export function updateComments(comments, operation){
  return function(dispatch, getState){
    const poemID = getState().course.url.poem,
          url = `/api/entries/`,
          update = {pressurePoints: comments};
    const {lessonID} = getState().course.lesson

    axios.post(url, {update, poemID}).then((res) => {
      let text;

      const entries = res.data;

      if(operation === 'save'){
        text = "Comment Saved";
      } else if(operation === 'delete'){
        text = "Comment Deleted";
      }

      if(text) message.success(text);

      dispatch({
        type: 'UPDATE_ENTRIES',
        entries: entries
      });

      //Determine completion based on length and requiredEntries property
      const { requiredEntries } = getState().course.lesson.componentData;
      const totalPrompts = Object.keys(getState().course.lesson.componentData.pressurePoints).length;

      const totalAnswered = Object.values(getState().entries.pressurePoints).reduce((acc, val) => {
        const t = val.length > 0 ? acc +1 : acc;
        return t;
        }, 0);

      const numRequired = (requiredEntries && requiredEntries <= totalPrompts) ? requiredEntries : totalPrompts;
      
      const completed = getState().course.completions[lessonID];

      if(!completed && totalAnswered >= numRequired){
        dispatch(completeLesson());
      }else if(completed && totalAnswered < numRequired){
        dispatch(removeCompletion());
      }

    }).catch(err => {
      console.log(err);
      const errMsg = err.response ? err.response.data.error : '';
      message.error('Save Failed: ' + errMsg);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/entries.js